import {
  getAeLeadSourceField,
  getBaseSalaryField,
  getOteField,
  getQuotaAttainmentByTeamField,
  getRankOnTeamField,
  getRevenueField,
  getSalesCycleLengthField,
  getSalesMethodologiesField,
  getTeamSizeField,
} from '@/components/partials/jobs/JobsInquiryForm/utils/sectionFields';
import type {
  JobsSectionField,
  JobsSectionModels,
} from '@/components/partials/public-portfolio/PortfolioJobsInquirySection/PortfolioJobsInquirySectionProfile/types';

export default ({ inquiry }: JobsSectionModels): JobsSectionField[] => {
  return [
    getBaseSalaryField({ inquiry }),
    getOteField({ inquiry }),
    getRevenueField({ inquiry }),
    getSalesCycleLengthField({ inquiry }),
    getRankOnTeamField({ inquiry }),
    getTeamSizeField({ inquiry }),
    getQuotaAttainmentByTeamField({ inquiry }),
    getAeLeadSourceField({ inquiry }),
    getSalesMethodologiesField({ inquiry }),
  ];
};
